export class DroitBnbaccess {
    constructor(public id?: string,
                public userName?: string,
                public dateDeb?: Date,
                public dateFin?: Date,
                public userId?: string,
                public typeDroit?: string,
                public typeOuverture?: string,
                public codeAcces?: string) {
    }
}

export class AccesBnbaccess {
    constructor(public id?: string,
                public nom?: string,
                public typeAcces?: string,
                public sensOuverture?: string,
                public identifiantConstructeurSerrure?: string) {
    }
}

export class AdresseBnbaccess {
    constructor(public rue?: string,
                public codePostal?: string,
                public ville?: string,
                public pays?: string) {
    }
}

export class PreferenceUser {
    constructor(public heureDArriveeDePreference?: string,
                public heureDeDepartDePreference?: string) {
    }
}

export class HebergementBnbaccess {

    constructor(public id?: string,
                public nom?: string,
                public description?: string,
                public guidage?: string,
                public vignette?: any,
                public vignetteContentType?: string,
                public adresse?: AdresseBnbaccess,
                public preferenceUser?: PreferenceUser,
                public acces?: AccesBnbaccess[],
                public droits?: DroitBnbaccess[],
                public connecteur?: string,
                public numTelephone?: string) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess.model.ts